import React, { useState } from "react";
import Text from "../../components/Text";
import { fontSizes } from "../../constants/constants";
import { ReactSVG } from "react-svg";
import icons from "../../constants/icons";
import ViewReverse from "../../components/ViewReverse";
import VatNumberFunctional from "./index.function";
import Button from "../../components/Button";
import Divider from "../../components/Divider";
import ErrorText from "../../components/ErrorText";
import CustomInput from "../../components/CustomInput";

const VatNumber = () => {
  const {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    onSubmit,
    settingLoading,
    vatNumber,
    setVatNumber,
    error,
    setError,
    handleVatChange,
  } = VatNumberFunctional();

  return (
    <div className="min-h-full">
      <ViewReverse className="gap-5 items-center">
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? "rotate-180" : ""}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={getContentKey("vat_number")}
          color="text-black"
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className="border mt-6 border-grey px-5 p-6 shadow-light rounded-xl w-full">
        <>
          <ViewReverse>
            <div className="w-full pt-2">
              <CustomInput
                label={getContentKey("vat_number")}
                placeholder={getContentKey("enter_vat_number")}
                minLength={3}
                maxLength={20}
                isRounded
                value={vatNumber}
                onChange={handleVatChange}
                isError={error}
                inputClassName={'uppercase placeholder:normal-case'}
              />
            </div>
          </ViewReverse>
          <ErrorText text={error} />

          <Divider className="mt-6 mb-4 bg-grey" />
          <ViewReverse className={"gap-4 mb-4"}>
            <Button
              text={getContentKey("save_btn")}
              bgColor='bg-primary'
              className={'border border-transparent w-44 px-0 text-center py-3 h-10'}
              isDisabled={vatNumber?.length < 3}
              onClick={onSubmit}
              loading={settingLoading}
            />
            <Button
              text={getContentKey("cancel_btn")}
              className={"py-3 h-10 w-44"}
              color={'text-primary hover:text-white'}
              bgColor='bg-white hover:bg-primary'
              className={`border border-primary w-44 px-0 text-center`}
              onClick={() => navigate(-1)}
              loaderColor={'border-t-primary'}
              isDisabled={settingLoading}
            />
          </ViewReverse>
        </>
      </div>
    </div>
  );
};

export default VatNumber;